import { render, staticRenderFns } from "./AddressData.vue?vue&type=template&id=6beb2cae"
import script from "./AddressData.vue?vue&type=script&lang=ts"
export * from "./AddressData.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports